import { Link } from 'react-router-dom';
import { useCampaignItemRoutes } from 'components/pages/campaign-settings/campaign-auction/useCampaignItemRoutes';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { twMerge } from 'tailwind-merge';
import { TransactionLineItem } from 'types/domain';

interface ItemPaymentDetailsProps {
    item: TransactionLineItem['item'];
    className?: string;
}

const ItemPaymentDetails = (props: ItemPaymentDetailsProps) => {
    const { item, className = '' } = props;
    const currencySymbol = useCurrencySymbol();

    return (
        <div className={twMerge('flex flex-col gap-y-4 font-medium', className)}>
            <p className={'text-sm'}>Item Details</p>
            <div className={'flex items-center justify-between'}>
                <ItemPaymentDetailsMini item={item} />
                <p className={'whitespace-nowrap text-sm'}>
                    {currencySymbol} {item?.price}
                </p>
            </div>
        </div>
    );
};

const ItemPaymentDetailsMini = (props: ItemPaymentDetailsProps) => {
    const { item, className } = props;
    const imageUrl = item?.pictures?.length ? item.pictures[0].url : '';
    const itemRoutes = useCampaignItemRoutes();

    if (!item) {
        return null;
    }

    return (
        <div className={twMerge('flex items-center gap-x-4 font-medium', className)}>
            <div
                className={
                    'h-12 w-12 rounded bg-gray-300 bg-contain bg-local bg-center bg-no-repeat'
                }
                style={{ backgroundImage: `url(${imageUrl})` }}
            />
            <Link
                className={'text-black hover:text-black hover:underline'}
                to={itemRoutes.show(item.id)}
            >
                <p className={'text-sm'}>{item.name}</p>
            </Link>
        </div>
    );
};

export { ItemPaymentDetails, ItemPaymentDetailsMini };
export type { ItemPaymentDetailsProps };
